import styled from 'styled-components';

const InputThreadList = styled.input`
  width: 100%;
  background-color: transparent;
  border: 0;
  color: var(--on-background);
  font-family: 'Inter', sans-serif;
  font-size: 64px;
  font-weight: bold;
  padding: 8px 0;
  
  ::placeholder {
    color: var(--on-background-grey);
  }
`;

export default InputThreadList;
